// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2reCP","location":"Header_location__hU6Gs"};